.container {
  display: flex;
  align-items: center;
  gap: 1rem;
  font-weight: 600;
  composes: slideRight from global;
}

.container p {
  width: 100%;
}
